import React from "react";
import { Outlet } from "react-router-dom";

function PostServices() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default PostServices;
